import React, { Fragment, useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../context/auth/authContext";
import Alert from "../layouts/Alert";
import "../../styles/fonts.css";
const Register = (props) => {
  const authContext = useContext(AuthContext);
  const { registerUser, isAuthenticated, googleLogin, addError } = authContext;
  useEffect(() => {
    if (isAuthenticated) {
      props.history.push("/"); //redirect
    }
    //eslint-disable-next-line
  }, [isAuthenticated, props.history]);
  const [formData, setformData] = useState({
    displayName: "",
    email: "",
    password: "",
    password2: "",
  });
  const { displayName, email, password, password2 } = formData;
  const onChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    if (password.length < 6) {
      addError("Passwords must be at least 6 charachters long");
    } else if (password !== password2) {
      addError("Passwords do not match");
    } else {
      registerUser(formData);
    }
  };
  const google = () => {
    googleLogin();
  };
  return (
    <Fragment>
      <h1 className='mb-4 upperfont'>Register Account</h1>
      <hr></hr>
      <Alert />
      <form onSubmit={onSubmit}>
        <div id='formgroup1'>
          <div className='form-group'>
            <label htmlFor='register-display-name ' className="fontcool">Name</label>

            <input
              type='text'
              id='register-display-name'
              className='form-control simplefont'
              name='displayName'
              required
              onChange={onChange}
              value={displayName}
            />
          </div>
          <div className='form-group'>
            <label htmlFor='register-email' className="fontcool">Email address</label>
            <input
              type='email'
              className='form-control simplefont'
              name='email'
              id='register-email'
              required
              onChange={onChange}
              value={email}
            />
          </div>
        </div>
        <div className='form-group'>
          <label htmlFor='register-password' className="fontcool">Password</label>
          <input
            type='password'
            className='form-control simplefont'
            name='password'
            id='register-password'
            required
            onChange={onChange}
            value={password}
          />
          <small id='emailHelp' className='form-text text-muted simplefont'>
            Your password must be at least 6 charachters long.
          </small>

          <label htmlFor='register-password-2' className="fontcool">Confirm Password</label>
          <input
            type='password'
            className='form-control simplefont'
            name='password2'
            id='register-password-2'
            required
            onChange={onChange}
            value={password2}
          />
        </div>
        <button className='btn btn-dark btn-block slantfont'>Register</button>
      </form>
      <br></br>
      <h6 className='text-center simplefont'>-OR-</h6>
      <br></br>
      <button className='btn btn-danger btn-block slantfont' onClick={google}>
        <i className='fab fa-google left'></i> Log In With Google
      </button>
      <hr></hr>
      <span className="simplefont">Already have an Account? <Link to='/login'>Login here</Link></span>
    </Fragment>
  );
};

export default Register;
